export default class CancelError extends Error {
	name = 'CancelError'
}
